import MiniProgramPage from 'D:/zxl/workspace/saveWorkSpace/nongtou-uni/pages/index/index.vue'
wx.createPage(MiniProgramPage)